import { DownloadOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import { Instructions } from "../sub-components/instructions/instructions-transcription"

export interface SystemDownloadProps {
  label: string;
  onClickDownload: () => void;
}

export const SystemDownloadComponent = ({
  label,
  onClickDownload,
}: SystemDownloadProps) => {
  return (
    <>  
      <Col span={24}>
        <Row>
          <h3>Download storageCLI tool for {label} operating system</h3>
        </Row>
        <Row>
          <Col span={10}>
            <Button
              className="downloadButton"
              icon={<DownloadOutlined />}
              onClick={onClickDownload}
            >
              Download
            </Button>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Instructions />
      </Col>
    </>
  );
};
